import React, { Component } from 'react';
import Card from '../../../../components/Card';
import CardHeader from '../../../../components/CardHeader';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';
import RawTable from '../RawTable';
import ExportButton from '../../../../components/Export';

const RawCardContainer = styled.div`
  margin-top: 20px;
`;

export default class RawCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const formattedData = this.props.data;
    const { campaignId, saleTypeId, wineId, negociantId } = this.props;
    return (
      <RawCardContainer>
        <Card id="directVerticalGraph">
          <CardHeader
            title={I18n.t('negoce.raw.title')}
            fontSize="20px"
            rightComponents={
              negociantId ? (
                <ExportButton
                  xls
                  path={`/negociant/campaign/${campaignId}/raw_data/xls?negociant_id=${negociantId}&sale_type_id=${saleTypeId}&wine_id=${wineId}`}
                  newApi
                />
              ) : null
            }
          />
          <RawTable data={formattedData} />
        </Card>
      </RawCardContainer>
    );
  }
}
